function create(data){
    return window.axios.post('/api/transfer/create', data);
}
function recover(data){
    return window.axios.post('/api/transfer/recover', data);
}

export default {
    create,recover
}